import React, {Component} from 'react'
import {
  Popconfirm,
  message,
  Button,
  Spin,
  Card,
  Table,
  Modal,
  Form,
  Row,
  Select,
  DatePicker,
  Col,
} from 'antd'
import {decode} from 'utf8'
import ModalP from './Modal'
import ModalEdit from './ModalEdit'
import ModalDelete from './ModalDelete'
import ModalShow from './ModalShow'
import Moment from 'moment'

import {connect} from 'react-redux'

import {
  fetchCoupons,
  updateCoupon,
  deleteCoupon,
  fetchCouponsData,
} from 'appRedux/actions/Coupons'
import getDate from 'util/ConfigDates'

const Option = Select.Option
const FormItem = Form.Item

class Simple extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateFrom: getDate('dateFrom'),
      dateTo: getDate('dateTo'),
      visible: false,
      storeId: localStorage.getItem('store_id') || 0,
      validateDateFrom: '',
      helpDateFrom: '',
      validateDateTo: '',
      helpDateTo: '',
    }
  }

  showModal = () => {
    this.setState({
      visible: true,
    })
  }

  componentDidMount() {
    this.props.fetchCoupons()
    this.props.fetchCouponsData(this.state)
  }

  arrayC = () => {
    let array = this.props.placeStores
    return array.map((element, index) => {
      return (
        <Option key={index} value={element.id}>
          {decode(element.name)}
        </Option>
      )
    })
  }

  onHandleClick = event => {
    event.preventDefault()
    if (this.state.dateFrom !== '' && this.state.dateTo !== '') {
      this.props.fetchCouponsData(this.state)
    } else {
      if (this.state.dateFrom == '') {
        this.setState({
          validateDateFrom: 'error',
          helpDateFrom: 'Fecha desde es un campo obligatorio.',
        })
      } else {
        this.setState({validateStatusBranchOffice: '', helpBrachOffice: ''})
      }
      if (this.state.dateTo == '') {
        this.setState({
          validateDateTo: 'error',
          helpDateTo: 'Fecha hasta es un campo obligatorio.',
        })
      } else {
        this.setState({validateStatusBranchOffice: '', helpBrachOffice: ''})
      }
    }
  }

  handleChangeCombo = value => {
    this.setState({
      storeId: value,
    })
  }

  onClickDateFrom = (date, dateString) => {
    this.setState({
      dateFrom: dateString,
      validateDateFrom: '',
      helpDateFrom: '',
    })
  }

  onClickDateTo = (date, dateString) => {
    this.setState({dateTo: dateString, validateDateTo: '', helpDateTo: ''})
  }

  render() {
    const columns = [
      {
        title: 'Tienda',
        dataIndex: 'store_id',
        key: 'store_id',
        render: text => <span>{text}</span>,
      },
      {
        title: 'Oferta',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Expiración',
        dataIndex: 'expirationDate',
        key: 'expirationDate',
      },
      {
        title: 'Puntos',
        dataIndex: 'points',
        key: 'points',
      },

      {
        title: 'Ver',
        key: 'ver',
        render: (text,record) => (
        <span>
          <ModalShow   recording={record}/>
        </span>
      ),

      },
      {
        title: 'Acción',
        key: 'action',

        render: (text, record) => {
          return (
            <span>

              <ModalEdit dataState={this.state} recording={record} />
              <ModalDelete dataState={this.state} recording={record} />
            </span>
          )
        },
      },
    ]

    const {couponsData} = this.props

    let couponsDataDecode = []
    couponsDataDecode = couponsData.map(couponData => {
      console.log('viendo este cupon patroncito , ', couponData)
      return {
        categoryId: couponData.categoryId,
        creationDate: couponData.creationDate,
        description: decode(couponData.description),
        id: couponData.id,
        name: decode(couponData.name),
        points: couponData.points,
        store_id: couponData.store_id,
        expirationDate: couponData.expirationDate,
      }
    })

    return (
      <Card title="Administrar cupón">
        <ModalP />
        <br />
        <Card>
          <Form onSubmit={this.onHandleClick}>
            <Row>
              <Col span={12}>
                <FormItem
                  label="Desde :"
                  validateStatus={this.state.validateDateFrom}
                  help={this.state.helpDateFrom}
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                >
                  <DatePicker
                    defaultValue={Moment(this.state.dateFrom, 'YYYY-MM-DD')}
                    className="gx-mb-3 gx-w-100"
                    onChange={this.onClickDateFrom}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Hasta : "
                  validateStatus={this.state.validateDateTo}
                  help={this.state.helpDateTo}
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                >
                  <DatePicker
                    defaultValue={Moment(this.state.dateTo, 'YYYY-MM-DD')}
                    className="gx-mb-3 gx-w-100"
                    onChange={this.onClickDateTo}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Tienda :"
                  labelCol={{xs: 24, sm: 9, lg: 9, md: 9}}
                >
                  <Select
                    className="gx-mr-3 gx-mb-3"
                    defaultValue="Todas"
                    onChange={this.handleChangeCombo}
                    style={{width: 140}}
                  >
                    <Option value={0}>Todas</Option>
                    {this.arrayC()}
                  </Select>
                </FormItem>
              </Col>
              <Col span={9} className="gx-text-right">
                <Button type="primary" onClick={this.onHandleClick}>
                  <i className="icon icon-search" />
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
        <br />
        <br />

        <Table
          pagination={{pageSize: 4}}
          className="gx-table-responsive"
          columns={columns}
          dataSource={couponsDataDecode}
        />
      </Card>
    )
  }
}

function mapStateToProps({coupons, placeStores, couponsData}) {
  return {
    placeStores,
    coupons,
    couponsData,
  }
}

export default connect(
  mapStateToProps,
  {updateCoupon, fetchCoupons, deleteCoupon, fetchCouponsData},
)(Simple)



// WEBPACK FOOTER //
// ./src/routes/main/Cupons/admin/Table.js